var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.17 7.85012L10.49 14.5301L6.61 10.6501C6.42264 10.4639 6.16919 10.3593 5.905 10.3593C5.64082 10.3593 5.38737 10.4639 5.2 10.6501C5.01375 10.8375 4.90921 11.0909 4.90921 11.3551C4.90921 11.6193 5.01375 11.8728 5.2 12.0601L9.79 16.6501C9.97737 16.8364 10.2308 16.9409 10.495 16.9409C10.7592 16.9409 11.0126 16.8364 11.2 16.6501L18.58 9.27012C18.6737 9.17716 18.7481 9.06655 18.7989 8.94469C18.8497 8.82284 18.8758 8.69213 18.8758 8.56012C18.8758 8.42811 18.8497 8.2974 18.7989 8.17554C18.7481 8.05368 18.6737 7.94308 18.58 7.85012C18.3926 7.66387 18.1392 7.55933 17.875 7.55933C17.6108 7.55933 17.3574 7.66387 17.17 7.85012Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.4d6ce6f617fb91a7ef362f536b62be87.svg";
export { ForwardRef as ReactComponent };